import moment from 'moment';
import RestService from '../services/rest';

async function getUsersForRankings() {
  return RestService.getAuthenticated('productivityRanking/usersForRankings');
}

async function getExpeditionDashboardInfo(
  startDate,
  endDate,
  getCharts = '',
  selectedBranches,
  selectedOrderTypes,
  selectedUsers,
  typeDashboard,
) {
  const sDate = moment(startDate).format();
  const eDate = moment(endDate).format();
  return RestService.getAuthenticated(
    'productivityRanking/list/getExpeditionDashboardInfo',
    {
      startDate: sDate, endDate: eDate, getCharts,
    },
    undefined,
    {
      params: {
        selectedBranches, selectedOrderTypes, selectedUsers, typeDashboard,
      },
    },
  );
}

async function getReceiptDashboardInfo(
  startDate,
  endDate,
  getCharts = '',
  selectedBranches,
  selectedOrderTypes,
  selectedUsers,
  typeDashboard,
) {
  const sDate = moment(startDate).format();
  const eDate = moment(endDate).format();
  return RestService.getAuthenticated(
    'productivityRanking/list/getReceiptDashboardInfo',
    {
      startDate: sDate, endDate: eDate, getCharts,
    },
    undefined,
    {
      params: {
        selectedBranches, selectedOrderTypes, selectedUsers, typeDashboard,
      },
    },
  );
}

export default {
  getUsersForRankings,
  getExpeditionDashboardInfo,
  getReceiptDashboardInfo,
};
